export default __webpack_public_path__ + "static/media/logo_ancp.d08b4940.svg";